import React from "react";

const PrintableProduct = ({ product }) => {
  return (
    <div>
      <h2>Product Details</h2>
      <p>Product Code: {product.productref}</p>
      <p>Product: {product.productname}</p>
      <p>Location: {product.AssignDesc}</p>
      <p>Area: {product.area}</p>
      <img
        src={`data:image/svg+xml;base64,${product.prodqrcode}`}
        alt="QR Code"
        style={{ maxWidth: '200px', maxHeight: '200px' }}
      />
    </div>
  );
};

export default PrintableProduct;
